import React from 'react'

import { useDictionaryData } from '@/components/shared/DictionaryProvider/hooks'

import * as S from './styles'

import { useNavigationRange } from '../../../hooks/useNavigationRange'
import { Button } from '../../uikit/Button'
import { MODE } from '../../uikit/Button/constants'
import { IconGenerator } from '../../uikit/IconGenerator'
import { ChevronLeft, ChevronRight } from '../../uikit/Icons'

type ShortlistFooterProps = {
  selectedShortlistIndex: number
  onIndexChange: (newIndex: number) => void
  onSendToEmployee: () => void
  nProperties: number
  nSelectedShortlists?: number
  canSendToEmployee: boolean
}

export const ShortlistFooter = ({
  selectedShortlistIndex,
  onIndexChange,
  onSendToEmployee,
  nSelectedShortlists = 0,
  nProperties,
  canSendToEmployee,
}: ShortlistFooterProps) => {
  const {
    indexStartingAt1,
    canGoBack,
    canGoForward,
    handlePrevious,
    handleNext,
    shouldShowNavigation,
  } = useNavigationRange({
    selectedIndex: selectedShortlistIndex,
    nItems: nProperties,
    onIndexChange,
  })
  const { dictionary } = useDictionaryData()

  return (
    <S.FooterContainer>
      {shouldShowNavigation && (
        <S.NavigationContainer>
          <S.NavigationButton
            onClick={handlePrevious}
            disabled={!canGoBack}
            aria-label="Previous shortlist"
          >
            <IconGenerator iconComponent={ChevronLeft} width={6} height={12} />
          </S.NavigationButton>

          <S.IndexText>
            {indexStartingAt1} of {nProperties}
          </S.IndexText>

          <S.NavigationButton
            onClick={handleNext}
            disabled={!canGoForward}
            aria-label="Next shortlist"
          >
            <IconGenerator iconComponent={ChevronRight} width={6} height={12} />
          </S.NavigationButton>
        </S.NavigationContainer>
      )}

      <Button
        disabled={!canSendToEmployee}
        mode={MODE.primary}
        isFullWidth
        onClick={onSendToEmployee}
      >
        Send to {dictionary.employee} ({nSelectedShortlists})
      </Button>
    </S.FooterContainer>
  )
}
